import axios from "axios";
import { handleUnauthorizedError } from '../utils/HandleUnauthorizedError';

let isAlertShown = false;

const API = axios.create({
   baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
   withCredentials: true, // 全域帶 cookie
});

API.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            handleUnauthorizedError();
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

class BaseAPI {
    static async getWithAuth(url, query, token) {
        const config = {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            params: query ? query : {},
        };

        try {
            const response = await API.get(url, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }

    static async getWithoutAuth(url, query) {
        const config = {
            params: query ? query : {},
        };

        try {
            const response = await API.get(url, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }

    static async post(url, data) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/plain',
                }
            };
            const response = await API.post(url, data, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }

    static async postWithAuth(url, data, token) {
        const config = {
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                'Content-Type': 'application/json',
            }
        };
        try {
            const response = await API.post(url, data, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }

    static async putWithAuth(url, data, token) {
        const config = {
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                'Content-Type': 'application/json',
            }
        };
        try {
            const response = await API.put(url, data, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }

    static async deleteWithAuth(url, query, token) {
        const config = {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            params: query || undefined,
        };
        try {
            const response = await API.delete(url, config);
            return response.data;
        } catch (err) {
            console.error('API error', err.response.data);
            throw err;
        }
    }
}

export default BaseAPI;